"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAnnotation = void 0;
const index_1 = require("../Base/index");
/**
 * Describes a BPMN TextAnnotation element.
 */
class TextAnnotation extends index_1.BaseElement {
}
exports.TextAnnotation = TextAnnotation;
//# sourceMappingURL=TextAnnotation.js.map